import React, { memo } from 'react';

import { FormattedMessage } from 'react-intl';

import { messages } from 'ui-components/components/weight-input/messages';

import { UnitDisplayType, UnitDisplayTypePropType } from '../../../../enums/units/unit-display-type';

export const GramsLabel = memo(({ unitDisplayType = UnitDisplayType.Abbreviated }) =>
  unitDisplayType === UnitDisplayType.AbbreviatedWithParentheses ? (
    <FormattedMessage {...messages.unitGramsWithParentheses} />
  ) : (
    <FormattedMessage {...messages.unitGrams} />
  ),
);

GramsLabel.propTypes = {
  unitDisplayType: UnitDisplayTypePropType,
};
